export default {
    _cartoon_whoops: 'cartoon-whoops',
    _clickSound: 'clickSound',
    _fast_whoosh_1: 'fast-whoosh-1',
    _fast_whoosh_2: 'fast-whoosh-2',
    _fast_whoosh_3: 'fast-whoosh-3',
    _fast_whoosh_4: 'fast-whoosh-4',
    _hit_key: 'hit-key',
    _loop_then_pop: 'loop-then-pop',
}